export default Object.freeze({
  // ERR_API_
  ERROR: '오류가 발생하였습니다.', // ERR_API_ERROR
  SUCCESS: '성공',
  FAIL: '실패',
  CNT: '건',
})
